import React from "react";
import { LegalLinks } from "app/pages/misc/Legal";

// the legal pages have to be reachable from every page (§5 DDG, Art. 13 DSGVO)
export const Footer: React.FC = () => (
    <footer className="c-footer">
        <LegalLinks className="c-navigation__link" />
    </footer>
);
